function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.9 13.3c-1.4-5.2-5.5-9.3-10.7-10.7C98.7 0 60.7 0 60.7 0s-38 0-47.5 2.5C8.1 3.9 3.9 8.1 2.5 13.3 0 22.8 0 42.5 0 42.5s0 19.8 2.5 29.2C3.9 76.9 8 81 13.2 82.4 22.8 85 60.7 85 60.7 85s38 0 47.5-2.5c5.2-1.4 9.3-5.5 10.7-10.7 2.5-9.5 2.5-29.2 2.5-29.2s.1-19.8-2.5-29.3z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M80.2 42.5L48.6 24.3v36.4z"
});

function SvgYoutube(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 90"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAgOTAiPjxwYXRoIGQ9Ik0gMTE4LjksMTMuMyBDIDExNy41LDguMSAxMTMuNCw0IDEwOC4yLDIuNiA5OC43LDAgNjAuNywwIDYwLjcsMCA2MC43LDAgMjIuNywwIDEzLjIsMi41IDguMSwzLjkgMy45LDguMSAyLjUsMTMuMyAwLDIyLjggMCw0Mi41IDAsNDIuNSAwLDQyLjUgMCw2Mi4zIDIuNSw3MS43IDMuOSw3Ni45IDgsODEgMTMuMiw4Mi40IDIyLjgsODUgNjAuNyw4NSA2MC43LDg1IGMgMCwwIDM4LDAgNDcuNSwtMi41IDUuMiwtMS40IDkuMywtNS41IDEwLjcsLTEwLjcgMi41LC05LjUgMi41LC0yOS4yIDIuNSwtMjkuMiAwLDAgMC4xLC0xOS44IC0yLjUsLTI5LjMgeiIgLz48cG9seWdvbiBwb2ludHM9IjgwLjIsNDIuNSA0OC42LDI0LjMgNDguNiw2MC43IiBzdHlsZT0iZmlsbDojZmZmZmZmIi8+PC9zdmc+";
export { SvgYoutube as ReactComponent };